import { AddressEditFormValues } from "./types";

export const initialAddressEditFormValues: AddressEditFormValues = {
  country: null,
  state: null,
  city: null,
  postalCode: null,
  line1: null,
  line2: null,
  latitude: null,
  longitude: null,
};
